import { SVGInterface } from "../../interface";

const ReadyTracker = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_441_61886)">
      <path
        d="M0.677734 10.8883L5.39046 15.6011L6.56546 14.4177L1.85689 9.70919L0.677734 10.8883ZM18.9398 4.40171L10.1071 13.2427L6.57642 9.70369L5.38475 10.8787L10.1071 15.6011L20.1232 5.58504L18.9398 4.40171ZM15.4078 5.58373L14.2328 4.40039L8.9238 9.7094L10.1071 10.8844L15.4078 5.58373Z"
        fill={color || "#2D2D2D"}
      />
    </g>
    <defs>
      <clipPath id="clip0_441_61886">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.400391)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ReadyTracker;
